import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { TABLE_LINK_SEPARATOR, TABLE_MULTIPLE_SEPARATOR } from '@app/modules/table/constants/table.constants';

/**
 * Ячейка для типа данных 'link'
 */
@Component({
    selector: 'app-link-cell',
    template: `
        <ng-container *ngIf="links.length > 0; else useRawValue">
            <ng-container *ngFor="let link of links; let idx = index">
                <ng-container *ngIf="idx > 0">, </ng-container>
                <a [href]="link.url | stripHtml" [fuiTooltip]="link.url" target="_blank">{{ link.text | stripHtml }}</a>
            </ng-container>
        </ng-container>
        <ng-template #useRawValue>
            <span [innerHtml]="getRawValue()"></span>
        </ng-template>
    `,
    styleUrls: ['./link-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkCellComponent extends BaseCellComponent implements OnInit {
    links: { url: string; text: string }[] = [];

    ngOnInit() {
        if (this.row[this.alias] === undefined || this.row[this.alias] === null) {
            return;
        }

        if (typeof this.row[this.alias] === 'object') {
            const name = this.row[this.alias].name;
            this.links = [{ url: this.row[this.alias].url, text: !!name ? name : this.row[this.alias].url }];
            return;
        }

        // Пример данных: НазваниеСсылки1:LINK:http://ya.ru:BREAK:НазваниеСсылки2:LINK:http://mail.ru
        if (typeof this.row[this.alias] === 'string') {
            const values = (this.row[this.alias] as string).split(TABLE_MULTIPLE_SEPARATOR);
            this.links = values
                .map((value) => value.split(TABLE_LINK_SEPARATOR))
                .map((parts) => (parts.length === 2 ? { url: parts[1], text: parts[0] } : null))
                .filter((link) => link !== null)
                .map((link) => (link.text === '' ? { ...link, text: link.url } : link));
            return;
        }
    }
}
